  <template>
  <div>
   <b-modal style="padding:15px" size="lg" id="EditFlourTypeModal" ref="modal" title="Edit Flour Type" ok-title="Submit" cancel-title="Close" 
      @hidden= "resetModal()"  @show= "updateModal()" @ok= "handleOk" :ok-disabled = "this.$refs.EditFlourTypeForm != undefined ? !this.$refs.EditFlourTypeForm.checkValidity() : true">
        <form ref="EditFlourTypeForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
           
            <div class="col-md-6">
               <b-form-group  label="Name" label-for="type-input" autocomplete="off">
                <b-form-input id="type-input" v-model= "TypeName"  required></b-form-input>
              </b-form-group>
            </div>
             <div class="col-md-6">
              <b-form-group label="Flour Type">
                <b-form-radio-group
                  v-model="BaseType"
                  :options="BaseTypes"
                  name="radio-inline"
                ></b-form-radio-group>
              </b-form-group>
            </div>
          </div>     
        </form>
      </b-modal>
      <Toaster ref= "toaster"/>
      </div>
      </template>

      <script>
import axios from 'axios';
// import config from '../config.js';
import Toaster from '../../toaster'

export default {
    name: 'EditFlourType',
    data(){
        return{
          moduleName:'Edit Flour Type',   
          TypeName:'',
          BaseType:1,
          Id:null,
          CompanyId:null,
          BaseTypes: [
            { text: 'Govt',  value: 1 },
            { text: 'Other',  value: 2 },
          ],
		}
  },
components:{
  Toaster,
},
props:{
  flourTypeToEdit:{
    type:Object,
    default:null
  }
},

methods:{
  
   editFlourType(){ 
        
     axios.post('/flourtype/edit', 
      {"Id":this.Id,"TypeName":this.TypeName, "CompanyId":this.$auth.user().companyId,"BaseType":Number(this.BaseType)
      })
      .then(res=>{
            if(res.data.status == 1)
            {
               
                  this.$refs.toaster.showToast('Sucess','success','Flour type has been updated successfully')
                  this.$bvModal.hide('EditFlourTypeModal')
                  this.$parent.getFlourTypes();  
            }
            else if(res.data.status == -1)
            {
              
                this.$refs.toaster.showToast('Error','error',res.data.msg)
             
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.EditFlourTypeForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
     
      resetModal() {
        this.TypeName = '';  
      },
      updateModal()
      {
        this.BaseType = this.flourTypeToEdit.baseType;
        this.TypeName = this.flourTypeToEdit.name;
        this.Id = this.flourTypeToEdit.id;
        
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.editFlourType()
       
      },

 

  }
	

}
</script>
